/* 筛选按钮<el-popover
  placement="bottom"
  width="300"
  v-model="popoverVisible">
  <el-checkbox-group v-model="propList">
    <el-checkbox :label="item" v-for="(item, index) in allPropList" :key="index" style="width: 120px">{{item.label}}</el-checkbox>
  </el-checkbox-group>
  <el-button slot="reference" size="small" style="float: right;">筛选</el-button>
</el-popover> */

/* 循环列<el-table-column
  :label="item.label"
  :prop="item.prop"
  :min-width="item.width"
  :sortable="item.sortable ? 'custom' : false"
  show-overflow-tooltip
  v-for="item in sortedPropList" :key="item.prop"
>
  <template slot-scope="scope">
    <template>
      {{scope.row[item.prop]}}
    </template>
  </template>
</el-table-column> */

// 导出
// const loading = this.$loading({
//   lock: true,
//   text: 'Loading',
//   spinner: 'el-icon-loading',
//   background: 'rgba(0, 0, 0, 0.7)'
// });
// let params = {
//   taskDTO: {
//     appCode: "ec-pc-api",
//     // 数据过滤
//     paramMap: {
//       exportTag: true,
//       ...this.searchForm.filterData
//     },
//     reportName: "skuExport"
//   },
//   // 配置导出列
//   columnDTOs: [
//     // {
//     //   columnName: '包件编码',
//     //   parentColumnName: null,
//     //   fieldName: 'packCode',
//     //   fieldType: 'string',
//     //   columnFormat: null
//     // }
//   ]
// };
// let labels = this.sortedPropList.map(v=>v.label);
// let props = this.sortedPropList.map(v=>v.prop);
// props.forEach((prop, index) => {
//   params.columnDTOs.push({
//     columnName: labels[index],
//     parentColumnName: null,
//     fieldName: prop,
//     fieldType: 'string',
//     columnFormat: null
//   })
// })
// // 不导出图片列
// params.columnDTOs = params.columnDTOs.filter(v=>v.columnName !== '图片');
// this.$q.common.customExportExcel({data: params}).then((res) => {
//   console.log(res)
//   loading.close();
//   this.$message({
//     type: "success",
//     message: "导出成功,请在导出列表中查看",
//   });
// });
import { hasPermit } from '@/utils/permission'

export default {
  data () {
    return {
      columnData: [],
      tableDataSet: [],
      reportName: 'productBaseList',
      tableVisible: false,
      tableReload: true,
      iSShowEngineeringDrawing: false,
      iSShowDOMProductInformation: false,
      isShowDeliveryCycle: false,
      isShowProductSupplier: false
    }
  },
  mounted () {
    this.iSShowEngineeringDrawing = hasPermit('ec-pc-new$goodsManage$basicInformationManagement$productList$engineeringDrawing')
    this.iSShowDOMProductInformation = hasPermit('ec-pc-new$goodsManage$basicInformationManagement$productList$DOMProductInformation')
    this.isShowDeliveryCycle = hasPermit('ec-pc-new$goodsManage$basicInformationManagement$productList$DeliveryCycle')
    this.isShowProductSupplier = hasPermit('ec-pc-new#productSpuplier')
    this.columns()
  },
  methods: {
    columns (type) {
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then(res => {
        this.columnsData = res.data
        const data = res.data.userColumns.length !== res.data.sysColumns.length ? res.data.sysColumns : res.data.userColumns
        let list = []
        data.forEach(v => {
          list.push({
            displayName: v.displayName,
            displayWidth: v.displayWidthNum,
            freezeLeft: v.freezeType === 'left',
            freezeRight: v.freezeType === 'right',
            isShow: v.isShow,
            columnName: v.columnName
          })
        })
        list = !this.iSShowEngineeringDrawing ? list.filter(v => v.displayName !== '工程图') : list
        list = !this.iSShowDOMProductInformation ? list.filter(v => v.displayName !== 'DDM产品信息') : list
        list = !this.isShowDeliveryCycle ? list.filter(v => v.displayName !== '发货周期') : list
        list = !this.isShowProductSupplier ? list.filter(v => v.displayName !== '产品供应商') : list
        this.tableDataSet = list
        if (!type) {
          this.customColumn(this.columnsData)
        }
      })
    },
    closeAddForm () {
      this.tableVisible = false
      this.columns(true)
    },
    confirm () {
      const data = []
      console.log(this.tableDataSet)
      this.tableDataSet.forEach(v => {
        const freezeFlag = !!(v.freezeLeft || v.freezeRight)
        data.push({
          displayName: v.displayName,
          columnName: v.columnName,
          displayWidth: v.displayWidth,
          reportName: this.reportName,
          freezeFlag: freezeFlag,
          freezeType: freezeFlag && v.freezeLeft ? 'left' : freezeFlag && v.freezeRight ? 'right' : '',
          isShow: v.isShow
        })
      })
      this.$q.common.mergeColumns({ data: data }).then(res => {
        if (res.success) {
          this.$message.success('自定义配置成功')
          this.tableReload = false
          this.$nextTick(_ => {
            this.tableReload = true
          })
          this.columns()
        } else {
          this.$message.error('自定义配置失败')
        }
        this.closeAddForm()
      })
    },
    async customColumn (data) {
      if (data.userColumns.length !== data.sysColumns.length) {
        data = data.sysColumns
      } else {
        data = data.userColumns.filter(v => !v.isShow)
      }
      this.columnData = []
      data.forEach(v => {
        this.columnData.push({
          label: v.displayName,
          prop: v.columnName,
          width: v.displayWidth,
          sortable: v.sortable === '1' ? 'custom' : false,
          span: false,
          fixed: v.freezeType
        })
      })
      this.columnData = !this.iSShowEngineeringDrawing ? this.columnData.filter(v => v.label !== '工程图') : this.columnData
      this.columnData = !this.iSShowDOMProductInformation ? this.columnData.filter(v => v.label !== 'DDM产品信息') : this.columnData
      this.columnData = !this.isShowDeliveryCycle ? this.columnData.filter(v => v.label !== '发货周期') : this.columnData
      this.columnData = !this.isShowProductSupplier ? this.columnData.filter(v => v.label !== '产品供应商') : this.columnData
    }
  }
}
